import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class StripeConfigService {
  private publicKey: string;
  constructor(private readonly http: HttpService) {}

  loadStripeConfig(): Observable<any> {
    return this.http
      .get('assets/config.json')
  }
  setPublicKey(key: string): void {
    this.publicKey = key;
  }

  getPublicKey(): string {
    return this.publicKey;
  }
}
